import { api } from "../../../services/Api";

async function solicitarAtualizacaoGeral({ dataInicio, dataFim, lote }) {
  const { data } = await api.post(
    "/ativa/faturamento/sincronizaTabelaLote/",
    null,
    {
      params: {
        dataInicio,
        dataFim,
        lote,
      },
    },
  );

  return data;
}

async function solicitarSincronizacaoIndividual({ idLote, lote, convenio }) {
  const { data } = await api.post(
    "/ativa/faturamento/sincronizaTabelaLoteIndividual/",
    null,
    {
      params: {
        id_lote: idLote,
        lote,
        convenio,
      },
    },
  );

  return data;
}

export { solicitarAtualizacaoGeral, solicitarSincronizacaoIndividual };
